'use client';
import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { UserAuth } from '@/app/context/AuthContext';

// Signed-in users go to Explore when tapping the logo; everyone else goes home.
const LogoLink = () => {
	const { user } = UserAuth();

	return (
		<Link href={user ? '/explore' : '/'}>
			<Image
				alt='logo'
				style={{ cursor: 'pointer' }}
				src='https://i.imgur.com/6ioQ9rW.png'
				width={200}
				height={30}
				layout='intrinsic'
				loading='eager'
				aspectratio={600 / 90}
				fetchPriority='high'
				priority
			/>
		</Link>
	);
};

export default LogoLink;
